/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminBarberPinUpdateInput } from "../../entities/models/AdminBarberPinUpdateInput";
import { z } from "zod/v4";

export const modelsAdminBarberPinUpdateInputSchema = z.object({
    "pin_code": z.string().min(6).max(6)
    }) as unknown as z.ZodType<ModelsAdminBarberPinUpdateInput>